import React, { useCallback, useEffect, useState } from 'react'
import { Outlet, useSearchParams } from 'react-router-dom'
import { Box, useTheme } from '@mui/material'

import TryAgainMessageBlock from '../../components/common/TryAgainMessageBlock'
import AuditPageHeader from '../../components/audit/AuditPageHeader'
import { getCountString, Icons } from '../../utils/utilities'
import api from '../../service/api'

const AuditExams = () => {

    const [searchParams] = useSearchParams( { searchText: "", month: "", selectedDepartment: "all", selectedInstitute: "all", view: "tabular", sortByName: "1", sortBySubmissionsCount: "1", sortByAssignmentCount: "1" } )
    const selectedInstitute = searchParams.get( 'selectedInstitute' ) || "all"
    const selectedDepartment = searchParams.get( 'selectedDepartment' ) || "all"


    const [error, setError] = useState( false )
    const [counts, setCounts] = useState( {} )
    const [loading, setLoading] = useState( true )

    const { layout } = useTheme()

    const getCounts = useCallback( async () => {
        try {
            setLoading( true )
            const department = selectedDepartment !== "all" ? selectedDepartment : ""
            const institute = selectedInstitute !== "all" ? selectedInstitute : ""
            const { data: { data: counts } } = await api.audit.getExamsCounts( { last30dayscount: true, institute, department } )
            setCounts( counts )
            setError( null )
        } catch ( err ) {
            console.log( err?.response?.data )
            setError( { code: err?.response?.status || null, message: err?.response?.data?.message || "Something went wrong while fetching the assignment audit data." } )
        } finally {
            setLoading( false )
        }
    }, [selectedInstitute, selectedDepartment] )

    useEffect( () => {
        getCounts()
    }, [getCounts] )


    return (
        <Box padding={layout.pagePadding} display="flex" flexDirection="column" gap={layout.sectionsGap} overflow="auto" flexGrow={1}>


            {/* Header */}
            <AuditPageHeader
                loading={loading}
                title="Exams audit"
                subtitle="View all exams activities here."
                countCards={[
                    {
                        icon: Icons.default.QuizIcon,
                        label: "Exams",
                        value: getCountString( counts.totalExams || 0 ),
                        secondary: getCountString( counts.last30daysCount || 0 ),
                        secondaryLabel: "In last 30 days"
                    },
                    {
                        icon: Icons.default.Group,
                        label: "Attempts",
                        value: getCountString( counts.totalAttemptsCount || 0 ),
                        secondary: getCountString( counts.last30daysAttemptsCount || 0 ),
                        secondaryLabel: "In last 30 days"
                    },
                ]}
            />

            {error && <Box sx={{ padding: "20px", flexShrink: 0 }}>
                <TryAgainMessageBlock getData={getCounts} err={error.message} code={error.code} loading={loading} />
            </Box>}
            <Outlet />
        </Box >
    )
}

export default AuditExams
